import React from 'react';
import Icon from '../../../components/AppIcon';

const SustainabilityScorecard = ({ title, data, overallScore }) => {
  const getScoreColor = (score) => {
    if (score >= 80) return 'text-success';
    if (score >= 60) return 'text-warning';
    return 'text-error';
  };

  const getScoreBgColor = (score) => {
    if (score >= 80) return 'bg-success';
    if (score >= 60) return 'bg-warning';
    return 'bg-error';
  };

  const getGradeFromScore = (score) => {
    if (score >= 90) return 'A+';
    if (score >= 80) return 'A';
    if (score >= 70) return 'B';
    if (score >= 60) return 'C';
    return 'D';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 card-shadow">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">{title}</h3>
        <div className="text-center">
          <div className={`text-3xl font-bold ${getScoreColor(overallScore)}`}>
            {getGradeFromScore(overallScore)}
          </div>
          <div className="text-xs text-muted-foreground">ESG Score</div>
        </div>
      </div>
      <div className="space-y-4">
        {data?.map((item, index) => (
          <div key={index} className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <Icon name={item?.icon} size={16} className="text-muted-foreground" />
                <span className="text-sm font-medium text-foreground">{item?.category}</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className={`text-sm font-bold ${getScoreColor(item?.score)}`}>
                  {item?.score}
                </span>
                <div className="flex items-center space-x-1">
                  {item?.trend === 'up' && <Icon name="ArrowUp" size={12} className="text-success" />}
                  {item?.trend === 'down' && <Icon name="ArrowDown" size={12} className="text-error" />}
                  {item?.trend === 'stable' && <Icon name="Minus" size={12} className="text-muted-foreground" />}
                  <span className="text-xs text-muted-foreground">{item?.change}</span>
                </div>
              </div>
            </div>
            
            <div className="w-full bg-muted rounded-full h-1.5">
              <div 
                className={`h-1.5 rounded-full transition-all duration-300 ${getScoreBgColor(item?.score)}`}
                style={{ width: `${item?.score}%` }}
              />
            </div>
            
            <div className="flex justify-between text-xs text-muted-foreground">
              <span>{item?.description}</span>
              <span>Target: {item?.target}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <div className="grid grid-cols-3 gap-4 text-center">
          <div>
            <div className="text-lg font-bold text-success">{data?.filter(item => item?.score >= 80)?.length}</div>
            <div className="text-xs text-muted-foreground">Excellent</div>
          </div>
          <div>
            <div className="text-lg font-bold text-warning">{data?.filter(item => item?.score >= 60 && item?.score < 80)?.length}</div>
            <div className="text-xs text-muted-foreground">Good</div>
          </div>
          <div>
            <div className="text-lg font-bold text-error">{data?.filter(item => item?.score < 60)?.length}</div>
            <div className="text-xs text-muted-foreground">Needs Improvement</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SustainabilityScorecard;